import { createSlice } from '@reduxjs/toolkit';

interface ErrorState {
    error: boolean;
    status: number | undefined;
    message: string;
}

const initialState: ErrorState = {
    error: false,
    status: null,
    message: ''
};

export const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setError: (state, action) => {
            state.error = true;

            const { response } = action.payload;

            if (response) {
                state.status = response.status;
            }
            else {
                state.status = 500;
            }
        },
        setAlert: (state, action) => {
            state.error = true;

            const { response } = action.payload;

            if (response) {
                state.message = response.data.message;
            }
            else {
                state.message = 'An unexpected error ocurred.';
                // state.status = 500;
            }
        },
        clearError: state => {
            state.error = false;
            state.status = null;
            state.message = '';
        }
    }
});

export const { setError, setAlert, clearError } = errorSlice.actions;

export default errorSlice.reducer;